/* Full Feast — keep the cart reward bar in step with the cart.
   The bar is rendered server-side by Liquid; this only refreshes it when the
   cart changes without a page load (drawer add, quantity change). It reads
   /cart.js, whose total_price is AFTER cart-level automatic discounts — the
   same figure Shopify tests the free-shipping condition against. */
(function () {
  // Symbol comes from what the server already rendered, never hardcoded —
  // an earlier version printed '£' onto a euro cart.

  // The international threshold arrives in GBP minor units. Shopify sets the
  // discount minimum in GBP and converts it at checkout; Shopify.currency.rate
  // is that same rate, so converting here keeps the bar and the till in step.
  function resolveThreshold(el) {
    var gbp = parseInt(el.dataset.thresholdGbp, 10);
    if (gbp > 0) {
      var rate = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
      if (rate > 0) {
        el.dataset.threshold = String(Math.round(gbp * rate));
        el.classList.remove('is-pending');
      }
    }
    return parseInt(el.dataset.threshold, 10) || 0;
  }

  function paint(cart) {
    document.querySelectorAll('[data-ff-progress]').forEach(function (el) {
      var threshold = resolveThreshold(el);
      var isDiscountTier = !!el.dataset.thresholdGbp;

      // Which figure to measure against depends on the reward.
      // Free delivery (UK): Shopify tests the shipping condition on the
      // discounted total, so total_price is right.
      // 10% off (international): Shopify tests the discount minimum on the
      // subtotal BEFORE the discount. Measuring total_price here made the bar
      // say "almost there" the moment the discount applied, because the
      // discount itself dragged the total back under the line.
      var total = isDiscountTier ? (cart.items_subtotal_price || 0) : (cart.total_price || 0);
      var remaining = threshold - total;
      var pct = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 0;

      // For the discount tier the ground truth is whether Shopify has applied
      // it, not our arithmetic. If it is on the cart, the bar is unlocked.
      if (isDiscountTier) {
        var apps = cart.cart_level_discount_applications || [];
        if (apps.length > 0 && (cart.total_discount || 0) > 0) { remaining = 0; pct = 100; }
      }

      var fill = el.querySelector('[data-ff-progress-fill]');
      if (fill) fill.style.width = pct + '%';

      var track = el.querySelector('.ff-progress__track');
      if (track) track.setAttribute('aria-valuenow', Math.round(pct));

      el.classList.toggle('is-unlocked', remaining <= 0);
      el.classList.toggle('ff-progress--empty', (cart.item_count || 0) === 0);

      var tier2 = el.querySelector('[data-ff-progress-tier2]');
      if (tier2) tier2.classList.toggle('is-met', remaining <= 0);

      var msg = el.querySelector('[data-ff-progress-message]');
      if (msg) {
        // Reward text comes from the server, which knows the market.
        var reward = el.dataset.reward || 'free UK delivery';
        var body;
        // Message templates come from the theme translations (window.FF_I18N,
        // set in theme.liquid) so /fr/ and /de/ read French and German.
        var T = window.FF_I18N || {};
        var cap = reward.charAt(0).toUpperCase() + reward.slice(1);
        var fill = function (tpl) { return tpl.split('__RC__').join(cap).split('__R__').join(reward); };
        if (remaining <= 0) {
          body = T.progress_unlocked ? fill(T.progress_unlocked) : '<strong>' + cap + ' unlocked.</strong>';
        } else if (pct >= 75) {
          body = T.progress_almost ? fill(T.progress_almost) : '<strong>Almost there.</strong> A little more unlocks ' + reward + '.';
        } else if (pct >= 40) {
          body = T.progress_halfway ? fill(T.progress_halfway) : "<strong>You're over halfway</strong> to " + reward + '.';
        } else {
          body = T.progress_start ? fill(T.progress_start) : 'Add a little more to unlock <strong>' + reward + '</strong>.';
        }
        msg.innerHTML = body;
      }
    });
  }
  function refresh() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(paint)
      .catch(function () { /* leave the server-rendered state alone */ });
  }
  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (evt) {
    document.addEventListener(evt, refresh);
  });
  // Paint once on load so the converted threshold (and any discount Shopify
  // has already applied to total_price) is reflected before the first change.
  refresh();
  // The theme swaps cart markup in place; re-sync when it does.
  var pending;
  new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(refresh, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
